import { container, TYPES } from  "@/inversifyconfig/container.config";

//interfaces
import { IHttpRequest } from  "@/interfaces/IHttp";
import { PaginatedResponse } from  "@/interfaces/api/PaginatedResponse";
import { IActivityFeedFilterParams } from  "@/interfaces/activityFeed";



const http = container.get<IHttpRequest>(TYPES.IHttpRequest); 

export async function getActivityFeed(options?:IActivityFeedFilterParams, headers?: any): Promise<PaginatedResponse<any>> {
    const res = await http.get(`activityfeed`, {params: options || {}, headers: headers})

    if(res.data) {
        return Promise.resolve(res.data)
    }
    
    return Promise.reject(new Error(`Couldn't get activity feed data`))
}

export async function openCommentOnWeb(contentId: number, commentId: number) {
    const res = await http.get(`webaction/open/content/${contentId}/comment/${commentId}`)

    if(res.data) {
        return Promise.resolve(res.data)
    }
    
    return Promise.reject(new Error(`Couldn't get redirect`))
}

export async function postComment(appId: number, contentId: number, payload:{text: string}) {
    const res = await http.put(`app/${appId}/content/${contentId}/social`, {body: payload.text});

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Error posting comment, please try again.`))
}

export async function postCommentReply(appId: number, contentId: number, commentId: number, payload:{text: string}) {
    const res = await http.put(`app/${appId}/content/${contentId}/social/comments/${commentId}`, {body: payload.text});

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Error posting comment, please try again.`))
}

export async function getAppsForActivityFeed(top: number) {
    const res = await http.get(`apps?top=${top}&skip=0`)

    if(res.status === 200) {
        return Promise.resolve(res.data)
    }
    return Promise.reject(new Error(`Couldn't get app data`))
}

export async function contentLike(appId: number, contentId: number) {
    const res = await http.put(`app/${appId}/content/${contentId}/social/like`, {"source": "ActivityFeed"});

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Error with like content like functionality, please try again.`))
}

export async function contentUnlike(appId: number, contentId: number) {
    const res = await http.delete(`app/${appId}/content/${contentId}/social/like`, {});

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Error with like content like functionality, please try again.`))
}

export async function archiveContent(listId: number, contentId: number) {
    const res = await http.delete(`list/${listId}/removeitem/${contentId}`, {});

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Error with archiving content, please try again.`))
}

export async function commentLike(appId: number, contentId: number, commentId: number) {
    const res = await http.put(`app/${appId}/content/${contentId}/social/comments/${commentId}/like`, {});

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Error with like comment functionality, please try again.`))
}

export async function commentUnlike(appId: number, contentId: number, commentId: number) {
    const res = await http.delete(`app/${appId}/content/${contentId}/social/comments/${commentId}/like`, {});

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Error with unlike comment functionality, please try again.`))
}

export async function commentDelete(appId: number, contentId: number, commentId: number) {
    const res = await http.delete(`app/${appId}/content/${contentId}/social/comments/${commentId}`, {});

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Error with deleting comment, please try again.`))
}

export async function postActivityFeedOpenedEvent(activityFeedPanelType: 'full' | 'popout') {
    const res = await http.post('activityfeed/opened', {activityFeedPanelType})

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Could not post analytics event.`))

}

export async function approveModeratedContent(contentId: number) {
    const res = await http.put(`activityfeed/moderatedcontent/${contentId}/approve`, {});

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Error with approving the content, please try again.`))
}